import { forwardRef, memo } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const SearchWidget = memo(({ innerRef, placeholder = "", ...props }) => {
  const { t } = useTranslation();
  return (
    <Input
      ref={innerRef}
      prefix={<SearchOutlined className="text-gray-400 dark:text-primary" />}
      placeholder={placeholder ? placeholder : t("input.search")}
      id="input-search"
      className="w-[180px]"
      allowClear
      {...props}
    />
  );
});

export default forwardRef((props, ref) => (
  <SearchWidget innerRef={ref} {...props} />
));
